import './custom.scss';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './pages/Layout';
import Archive from './pages/archive/archive';
import Flows from './pages/flows/flows';
import Home from './pages/home/home';
import Summary from './pages/summary/summary';
import WatchDog from './pages/watchdog/watchdog';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="summary" element={<Summary />} />
          <Route path="archive" element={<Archive />} />
          <Route path="flows" element={<Flows />} />
          <Route path="watchdog" element={<WatchDog />} />
          <Route path="*" element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}